import { ArchivedDownloadBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/downloadBlock/archivedDownloadBlock.layout'
import { DownloadBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/downloadBlock/downloadBlock.layout'
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend'
import * as React from 'react'
import { dummyData, randomCaption, randomTitle } from '../../../config/dummyData'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsDownloadBlock = () => (
  <>
    <StyleguidePart title="Default Block" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentDownloadBlock />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart title="Archived Block" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentArchiveDownloadBlock />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentDownloadBlock = () => (
  <DownloadBlockLayout id="download-block-example" title={randomTitle()} intro={dummyData.intro} items={items} />
)

export const ComponentArchiveDownloadBlock = () => {
  const [open, setOpen] = React.useState(false)
  return (
    <ArchivedDownloadBlockLayout
      id="archive-download-block-example"
      items={items}
      isOpen={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    />
  )
}

const items = [
  {
    title: randomTitle(),
    text: randomCaption(),
    url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg'
  },
  {
    title: randomTitle(),
    text: randomCaption(),
    url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg'
  },
  {
    title: randomTitle(),
    url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-2048x1536.jpeg'
  }
]
